module.exports = __webpack_public_path__ + "ccf80c754fa39b542e05b920f6f1c377.svg";